import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import DatePicker from 'react-datepicker2';
//https://s-yadav.github.io/react-number-format/docs/numeric_format/
import NumberFormat from 'react-number-format';

export default class Form extends Base {
    constructor(props) {
        super(props);
        this.state = {
            caller: props.Caller,
            type: props.Type,
            loading: false,
            toTime: "",
            inputToTime: "",
            uiSettings: props.UiSettings,
        };

        this.state.inputFromTime = this.state.caller.state.data.record.formRequest.fromTime != 0 ? this.formatTimeForInput(this.state.caller.state.data.record.formRequest.fromTime.toString()) : "";
        this.state.inputToTime = this.state.caller.state.data.record.formRequest.toTime != 0 ? this.formatTimeForInput(this.state.caller.state.data.record.formRequest.toTime.toString()) : "";
    }
    formatTimeForInput = (timeString) => {
        if (timeString.length === 5)
            timeString = "0" + timeString;
        if (timeString.length === 6) {
            return `${timeString.slice(0, 2)}:${timeString.slice(2, 4)}:${timeString.slice(4, 6)}`;
        }
        return "";
    }
    validateTime = (timeString) => {
        if (!/^\d{6}$/.test(timeString)) return "فرمت ساعت نادرست است!";

        const hours = parseInt(timeString.slice(0, 2), 10);
        const minutes = parseInt(timeString.slice(2, 4), 10);
        const seconds = parseInt(timeString.slice(4, 6), 10);

        if (hours < 0 || hours > 23) return "ساعت باید بین 00 تا 23 باشد!";
        if (minutes < 0 || minutes > 59) return "دقیقه باید بین 00 تا 59 باشد!";
        if (seconds < 0 || seconds > 59) return "ثانیه باید بین 00 تا 59 باشد!";

        return "";
    }
    handleFromTimeChange = (e) => {
        const value = e.target.value; // مقدار ورودی در فرمت HH:mm:ss
        if (value) {
            const formattedTime = value.replace(/:/g, ""); // حذف دو نقطه
            var resValidate = this.validateTime(formattedTime);
            if (resValidate) {
                this.showErorrMessage(resValidate);
                return;
            }
            this.state.caller.state.data.record.formRequest.fromTime = formattedTime;
            this.setState({
                inputFromTime: value
            });
        } else {
            this.setState({
                time: ""
            });
        }
    }
    handleToTimeChange = (e) => {
        const value = e.target.value; // مقدار ورودی در فرمت HH:mm:ss
        if (value) {
            const formattedTime = value.replace(/:/g, ""); // حذف دو نقطه
            var resValidate = this.validateTime(formattedTime);
            if (resValidate) {
                this.showErorrMessage(resValidate);
                return;
            }
            this.state.caller.state.data.record.formRequest.toTime = formattedTime;
            this.setState({
                inputToTime: value
            });
        } else {
            this.setState({
                time: ""
            });
        }
    }
    getCaption() {
        if (this.state.type === 1) return "درخواست اضافه کاری";
        if (this.state.type === 2) return "درخواست ماموریت";
        if (this.state.type === 3) return "درخواست مساعده حقوق";
        return '';
    }
    renderForm() {
        return <div className="row" style={{ "backgroundColor": "beige", "paddingTop": "15px", "paddingBottom": "15px"}}>
            <div className="col-lg-12">
                <h4>{this.getCaption()}</h4>
            </div>
            {this.state.type === 2 && <div className="col-lg-2">
                <div className="form-group">
                    <label className="form-label">نوع</label>
                    <div className="form-control-wrap">
                        <select className="form-control" defaultValue={this.state.caller.state.data.record.formRequest.subType} onChange={e => this.state.caller.state.data.record.formRequest.subType = parseInt(e.target.value)}>
                            <option value="1">درون شهری</option>
                            <option value="2">برون شهری</option>
                            <option value="3">فوق العاده</option>
                        </select>
                    </div>
                </div>
            </div>}
            {this.state.type === 2 && <div className="col-sm-2">
                <div className="form-group">
                    <label className="form-label">از تاریخ :</label>
                    <div className="form-control-wrap">
                        <DatePicker
                            inputReadOnly={false}
                            className="form-control persian-date ltr"
                            placeholder={"تاریخ"}
                            isGregorian={false}
                            showTodayButton={true}
                            timePicker={false}
                            onChange={(e) => { this.state.caller.state.data.record.formRequest.fromDate = e }}
                            value={this.getFormatedDateForDatePicker(this.state.caller.state.data.record.formRequest.fromDate)}
                        />
                    </div>
                </div>
            </div>}
            {this.state.type === 1 && <div className="col-sm-2">
                <div className="form-group">
                    <label className="form-label">از ساعت:</label>
                    <div className="form-control-wrap">
                        <input
                            type="time"
                            value={this.state.inputFromTime}
                            onChange={e => this.handleFromTimeChange(e)}
                            className="form-control input-sm"
                            step="1"
                        />
                    </div>
                </div>
            </div>}
            {this.state.type === 2 && <div className="col-sm-2">
                <div className="form-group">
                    <label className="form-label">تا تاریخ :</label>
                    <div className="form-control-wrap">
                        <DatePicker
                            inputReadOnly={false}
                            className="form-control persian-date ltr"
                            placeholder={"تاریخ"}
                            isGregorian={false}
                            showTodayButton={true}
                            timePicker={false}
                            onChange={(e) => { this.state.caller.state.data.record.formRequest.toDate = e }}
                            value={this.getFormatedDateForDatePicker(this.state.caller.state.data.record.formRequest.toDate)}
                        />
                    </div>
                </div>
            </div>}
            {this.state.type === 1 && <div className="col-sm-2">
                <div className="form-group">
                    <label className="form-label">تا ساعت:</label>
                    <div className="form-control-wrap">
                        <input
                            type="time"
                            value={this.state.inputToTime}
                            onChange={e => this.handleToTimeChange(e)}
                            className="form-control input-sm"
                            step="1"
                        />
                    </div>
                </div>
            </div>}
            {this.state.type === 3 && <div className="col-lg-2">
                <div className="form-group">
                    <label className="form-label">مبلغ:</label>
                    <NumberFormat
                        value={this.state.caller.state.data.record.formRequest.price}
                        onChange={(e) => this.state.caller.state.data.record.formRequest.price = parseInt(e.target.value.replace(/,/g, ''))}
                        thousandSeparator={true}
                        prefix={''}
                        className="form-control"
                    />
                </div>
            </div>}
            {this.state.type === 2 && <div className="col-sm-3">
                <div className="form-group">
                    <label className="form-label">وسیله نقلیه:</label>
                    <div className="form-control-wrap">
                        <input
                            type="text"
                            defaultValue={this.state.caller.state.data.record.formRequest.car}
                            onChange={e => this.state.caller.state.data.record.formRequest.car = e.target.value}
                            className="form-control input-sm" />
                    </div>
                </div>
            </div>}
            {this.state.type === 2 && <div className="col-sm-3">
                <div className="form-group">
                    <label className="form-label">شماره پلاک:</label>
                    <div className="form-control-wrap">
                        <input
                            type="text"
                            defaultValue={this.state.caller.state.data.record.formRequest.carNo}
                            onChange={e => this.state.caller.state.data.record.formRequest.carNo = e.target.value}
                            className="form-control input-sm" />
                    </div>
                </div>
            </div>}
            {this.state.type === 2 && <div className="col-sm-6">
                <div className="form-group">
                    <label className="form-label">مقصد:</label>
                    <div className="form-control-wrap">
                        <input
                            type="text"
                            defaultValue={this.state.caller.state.data.record.formRequest.address}
                            onChange={e => this.state.caller.state.data.record.formRequest.address = e.target.value}
                            className="form-control input-sm" />
                    </div>
                </div>
            </div>}
            {this.getFieldVisable("form.description") && <div className="col-sm-12">
                <div className="form-group">
                    {this.state.type === 1 && <label className="form-label">توضیحات:</label>}
                    {this.state.type === 2 && <label className="form-label">جهت:</label>}
                    {this.state.type === 3 && <label className="form-label">علت درخواست:</label>}
                    <div className="form-control-wrap">
                        <input
                            type="text"
                            defaultValue={this.state.caller.state.data.record.formRequest.description}
                            onChange={e => this.state.caller.state.data.record.formRequest.description = e.target.value}
                            className="form-control input-sm" />
                    </div>
                </div>
            </div>}
            {this.getFieldVisable("form.notic") && this.state.type === 2 && <div className="col-sm-12">
                <div className="form-group">
                    <label className="form-label">تذکر:</label>
                    <div className="form-control-wrap">
                        <input
                            type="text"
                            defaultValue={this.state.caller.state.data.record.formRequest.notic}
                            onChange={e => this.state.caller.state.data.record.formRequest.notic = e.target.value}
                            className="form-control input-sm" />
                    </div>
                </div>
            </div>}
            {this.state.caller.state.data.record.id !== this.getDefaultGuid() && <div className="col-lg-2">
                <div className="form-group">
                    <label className="form-label">وضعیت</label>
                    <div className="form-control-wrap">
                        <select className="form-control" defaultValue={this.state.caller.state.data.record.formRequest.status} onChange={e => this.state.caller.state.data.record.formRequest.status = parseInt(e.target.value)}>
                            <option value="1">در انتظار بررسی</option>
                            <option value="2">موافقت شده</option>
                            <option value="3">موافقت نشده</option>
                        </select>
                    </div>
                </div>
            </div>}
        </div>

    }
    render() {
        return this.renderForm();
    }
}